var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"layout hall-layout"},[_c('div',{staticClass:"head"},[_c('hall-head')],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"headBg"},[_c('img',{attrs:{"src":require('@/assets/serviceHall/serviceHallBackground.png')}})]),_c('div',{staticClass:"router"},[_c('router-view')],1)]),_c('hall-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }